import { styled } from '@mui/material/styles'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'

export const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  flex: 1,
})

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  color: theme.palette.primary.main,
  alignItems: 'center',
}))

export const ContentWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  color: theme.palette.primary.main,
  flex: 1,
}))

export const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  cursor: 'pointer',
  '& .main-menu-close': {
    color: theme.palette.background.paper,
  },
}))

export const StyledSwiper = styled(SwipeableDrawer)(({ theme }) => ({
  '& .notification-sidebar': {
    zIndex: '10',
  },

  '& .main-menu > .container': {
    backgroundColor: theme.palette.background.slider,
  },

  '& .MuiPaper-root': {
    backgroundColor: 'transparent',
  },

  '& .container': {
    flex: 1,
    backgroundColor: theme.palette.background.paper,
    flexDirection: 'column',
    padding: 20,
  },
}))
